import React from 'react'
import { Select } from '@babylon/web-platform-ui'
import withField from '../withField'

const SelectField = withField(Select)

type OptionsType = { label: string; value: string }[]

interface SelectFieldWrapperProps {
  options: OptionsType
  name: string
}

const SelectFieldWrapper = ({
  options,
  name,
  ...props
}: SelectFieldWrapperProps) => (
  <SelectField name={name} {...props}>
    {options.map((o) => (
      <option key={o.value} value={o.value}>
        {o.label}
      </option>
    ))}
  </SelectField>
)

export default SelectFieldWrapper
